import { type ReduxUser, type EventEmailInvitee } from 'models';

export const isEmailInvitee = ({
  viewer,
  event: { emailInvitees },
}: {
  viewer: ReduxUser;
  event: { emailInvitees?: EventEmailInvitee[] }; // TODO correct event type
}) => emailInvitees?.some((invitee) => invitee.email === viewer.email);
